module.exports = __webpack_public_path__ + "static/media/Dranken.6a0aed4d.svg";